import React, { Component } from "react";
import SvgIcon from "material-ui/SvgIcon";
import { CloseIcon } from "../../icons";
import { getSpecificIcon } from "../../helpers/producttypes.js";
// import { priceToFix } from '../../helpers/productHelper';
import "./style.css";
import { getUomDisplayVal, isSize } from "../../helpers/attribute_util";
import { LIGHT_GREY } from "../../config/colors";
import { truncateProductName } from "../../helpers/productHelper";
class CartItem2 extends Component {
  getIcon = (name, isChecked) => {
    return getSpecificIcon(name, "#616161");
  };
  getWrapperClass = () => (this.props.isPaymentKiosk ? 'treezcart-item-wrapper-kiosk' : 'treezcart-item-wrapper');
  getBrandClass = () => (this.props.isPaymentKiosk ? 'treezcart-item-brand-kiosk' : 'treezcart-item-brand');
  getNameClass = () => (this.props.isPaymentKiosk ? 'treezcart-item-name-kiosk' : 'treezcart-item-name');
  getItemRight = () => (this.props.isPaymentKiosk ? 'treezcart-item-right-kiosk' : 'treezcart-item-right');
  getPurchaseIconClass = () => (this.props.isPaymentKiosk ? 'purchase-type-icon-kiosk' : 'purchase-type-icon');
  getQuantityIconClass = () => (this.props.isPaymentKiosk ? 'treezcart-item-qnt-kiosk' : 'treezcart-item-qnt');
  getAddIconStyle = () => (this.props.isPaymentKiosk ? { height: '50px', width: '50px' } : {});
  getRemoveIconStyle = () => (this.props.isPaymentKiosk ? { height: '50px', width: '50px' } : {});
  getItemPriceClass = () => (this.props.isPaymentKiosk ? "treezcart-item-price-kiosk" : "treezcart-item-price");
  getItemWeightClass = () => (this.props.isPaymentKiosk ? "treezcart-item-weight-kiosk" : "treezcart-item-weight");
  getItemQntTitleClass = () => (this.props.isPaymentKiosk ? "treezcart-item-qnt-title-kiosk" : "treezcart-item-qnt-title");
  getItemQntNumClass = () => (this.props.isPaymentKiosk ? "treezcart-item-qnt-title-kiosk" : "treezcart-item-qnt-title");
  getItemCenterSideClass = () => (this.props.isPaymentKiosk ? "treezcart-item-centerside-kiosk" : "treezcart-item-centerside");
  getItemActionClass = () => (this.props.isPaymentKiosk ? "treezcart-item-action-kiosk" : "treezcart-item-action");
  getCloseIconStyle = () => {
    return this.props.isPaymentKiosk ? { height: '50px', width: '50px' } : {};
  }
  getTreezCartItemLeftClass = () => {
    return this.props.isPaymentKiosk ? "treezcart-item-left-kiosk" : "treezcart-item-left"
  }
  getRemoveIconClass = () => {
    return this.props.isPaymentKiosk ? "treez-cart-item-remove-kiosk" : "treez-cart-item-remove";
  } //treezcart-item-qnt-title 

  getSize = (item) => {
    return parseFloat(item.size);
  }

  render() {
    const { item, edit, isPhone } = this.props;
    const color = ["#", this.props.color].join("");
    const colorStyle = { color: color };
    const price =
      this.props.ticketItems &&
        this.props.ticketItems[this.props.index] &&
        this.props.ticketItems[this.props.index].originalPrice
        ? this.props.ticketItems[this.props.index].originalPrice
        : 0;
    const unitOfMeasurement = getUomDisplayVal(item.unitOfMeasurement);
    const amount = isSize(item) ? <span>{this.getSize(item)}&nbsp;{unitOfMeasurement}</span> : <span>&nbsp;</span>
    return (
      <div>
        <div className={this.getWrapperClass()}>
          {edit && 
            <div className="treezcart-item-leftside">
                <div className={this.getRemoveIconClass()} onClick={this.props.onRemove}>
                  <CloseIcon
                    style={this.getCloseIconStyle()}
                    color={LIGHT_GREY}
                  />
                </div>
            </div>
          }

          <div className={this.getItemCenterSideClass()}>
            <div className="treezcart-item">
              <div className={this.getTreezCartItemLeftClass()}>
                <div className="purchase-type">
                  <span className={this.getPurchaseIconClass()}>
                    {this.getIcon(item.type.toUpperCase())}
                  </span>
                </div>
              </div>
              <div className={this.getItemRight()}>
                <div className={this.getBrandClass()}>{item.brand}</div>
                <div className={this.getNameClass()}>{isPhone ? truncateProductName(item.productName, 9) : item.productName}</div>
                <div className="treezcart-item-size-wrapper">
                  <span className="treezcart-item-pricesell">
                    {edit && <div className={this.getItemWeightClass()}>{amount}</div>}
                    {edit && <div style={colorStyle} className={this.getItemPriceClass()}>{(price * item.quantity).formatMoney()} </div>}
                    {!edit && 
                      <div style={colorStyle} className={this.getQuantityIconClass()}>
                        <span className={this.getItemQntTitleClass()}>QTY:</span>
                        <span className={this.getItemQntNumClass()}>{item.quantity} </span>
                      </div>
                    }
                  </span>
                </div>
              </div>
            </div>
          </div>

            <div className="treezcart-item-rightside">
              {edit && 
                <div className="treezcart-item-qty-input">
                  <div style={colorStyle} className={this.getQuantityIconClass()}>
                    <span className={this.getItemQntTitleClass()}>QTY:</span>
                    <span className={this.getItemQntNumClass()}>{item.quantity} </span>
                  </div>
                  <div className="treezcart-item-qty-controls">
                    <div
                      style={colorStyle}
                      className={this.getItemActionClass() + ' up'}
                      onClick={this.props.onQuantityUp}
                    >
                      <div style={{ height: 23 }}>
                        <AddIcon style={this.getAddIconStyle()} color={color} />
                      </div>
                    </div>
                    <div
                      style={colorStyle}
                      className={this.getItemActionClass() + ' down'}
                      onClick={this.props.onQuantityDown}
                    >
                      <div style={{ height: 22 }}>
                        <RemoveIcon style={this.getRemoveIconStyle()} color={color} />
                      </div>
                    </div>
                  </div>
                </div>
              }

              {!edit &&
                <div style={colorStyle} className={this.getItemPriceClass()}>
                  {(price * item.quantity).formatMoney()}
                </div>
              }
            </div>
        </div>
      </div>
    );
  }
}

export default CartItem2;

const AddIcon = props => (
  <SvgIcon {...props}>
    <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </SvgIcon>
);

const RemoveIcon = props => (
  <SvgIcon {...props}>
    <path d="M19 13H5v-2h14v2z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </SvgIcon>
);



// WEBPACK FOOTER //
// ./src/components/CartItem2/CartItem2.jsx